/**
 * Build a wa.me link that opens WhatsApp with the given message pre-filled.
 * @param {string} phone - digits only, with country code (e.g. "919999999999")
 * @param {string} message
 */
export function waLink(phone, message) {
  const digits = (phone || "").replace(/\D/g, "");
  const text = encodeURIComponent(message || "");
  return digits ? `https://wa.me/${digits}?text=${text}` : `https://wa.me/?text=${text}`;
}

/**
 * Open WhatsApp in a new tab with the given message pre-filled.
 */
export function openWhatsApp(phone, message) {
  window.open(waLink(phone, message), "_blank", "noopener,noreferrer");
}
